import { createSlice } from "@reduxjs/toolkit";
import{getMonthObject} from './dateHelper'
const initialState = {
  filter: {
    // month: { id: "2025-09-01|2025-09-30", label: "Sep 25" }, // ⬅️ store both
    month:getMonthObject(), // ⬅️ store both
    limit: 10,
    page: 1,
  },
  expenses: [],
};

const expenseSlice = createSlice({
  name: "expense",
  initialState,
  reducers: {
    setMonth: (state, action) => {
      state.filter.month = action.payload; // expect { id, label }
    },
    setLimit: (state, action) => {
      state.filter.limit = action.payload;
    },
    setPage: (state, action) => {
      state.filter.page = action.payload;
    },
    resetFilter: (state) => {
      state.filter = { ...initialState.filter };
    },
  },
});

export const { setMonth, setLimit, setPage, resetFilter } = expenseSlice.actions;
export default expenseSlice.reducer;
